import React from 'react';
import type { FC } from 'react';
import { CheckIcon } from './check-icon';
import { UncheckIcon } from './uncheck-icon';

interface SizeTileProps {
    title: string;
    thumbnail: string;
    size: string;
    isSelected?: boolean;
    onClick?: () => void;
}

export const SizeTile: FC<SizeTileProps> = ({ title, thumbnail, size, onClick, isSelected }) => {
    return (
        <div
            className="flex flex-col gap-2.5 aspect-square cursor-pointer"
            onClick={onClick}
            onKeyUp={(e) => e.key === 'Enter' && onClick && onClick()}
        >
            <div className="flex flex-row justify-between items-center overflow-hidden">
                <div className="flex flex-row gap-2 items-center max-w-[70%]">
                    <div className="flex-shrink-0">{isSelected ? <CheckIcon /> : <UncheckIcon />}</div>
                    <span className="text-xs text-white truncate">{title}</span>
                </div>
                <p className="text-xs text-gray-110 truncate max-w-[30%] text-right">{size}</p>
            </div>
            <div
                className={`${isSelected ? 'border-solid border-blue border-[1px]' : ''} bg-gray-160 rounded w-full h-full p-3`}
            >
                <img src={thumbnail} alt="thumbnail" className="w-full h-full rounded object-contain" />
            </div>
        </div>
    );
};
